<script lang="ts">
  import type { LandingPage } from '$lib/types/ServicePageTypes'
  import SEO from '$lib/components/seo/SEO.svelte'
  import H4 from '$lib/components/typography/H4.svelte'
  import H1 from '$lib/components/typography/H1.svelte'
  import SammenIcon from '$lib/components/icons/largeIcons/SammenIcon.svelte'
  import Body from '$lib/components/article/Body.svelte'
  import BodyWrapper from '$lib/wrappers/BodyWrapper.svelte'

  import { CtaDoubleSection, CtaSection } from '$lib/components/cta'

  export let data: LandingPage
  const { ingress, title, seo, body, ctaSection1, ctaSection2, ctaSectionDouble } = data
</script>

<SEO title={seo?.metaTitle || title} description={seo?.metaDescription || ingress} />

<BodyWrapper class="bg-primary-50 pt-10">
  <div class="">
    <div>
      <SammenIcon />
    </div>
    <div class="">
      <H1 class="text-gray-800 pb-4">{title}</H1>
      <H4 class="text-base-black pb-8">{ingress}</H4>
    </div>
  </div>
</BodyWrapper>
{#if body}
  <Body {body} />
{/if}
{#key ctaSectionDouble}
  <CtaDoubleSection {ctaSectionDouble} class="bg-base-white py-4 md:pb-8" />
{/key}
<CtaSection ctaSection={ctaSection1} />
<CtaSection ctaSection={ctaSection2} />
